/**
 * Hook de roteamento SPA nativo e reativo para o LegisCity.
 *
 * Gerencia a navegacao declarativa usando a History API do navegador
 * sem necessidade de bibliotecas externas pesadas.
 *
 * @module hooks/useRouter
 */

import { useState, useEffect, useCallback } from "react";

export function useRouter() {
  const [currentPath, setCurrentPath] = useState(() => window.location.pathname || "/");

  useEffect(() => {
    const handlePopState = () => {
      setCurrentPath(window.location.pathname || "/");
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  const navigate = useCallback((to, replace = false) => {
    if (window.location.pathname === to) return;

    if (replace) {
      window.history.replaceState({}, "", to);
    } else {
      window.history.pushState({}, "", to);
    }

    setCurrentPath(to);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const isActive = useCallback(
    (path) => {
      if (path === "/") return currentPath === "/";
      return currentPath.startsWith(path);
    },
    [currentPath]
  );

  return { currentPath, navigate, isActive };
}
